import axios from "axios";
//import {setToken} from "./auth.js"
import { useNavigate } from "react-router-dom";
import Keycloak from "keycloak-js";
import { keycloak } from "../keycloak";
const prod = "https://www.sptapp.eu/";
const dev = "https://www.sptapp.eu/";
export const axiosApiInstance = axios.create({
  baseURL: prod,
});
// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async (config) => {
    /*     const value = await redisClient.get(rediskey)
    const keys = JSON.parse(value) */
    const access = localStorage.getItem("token");
    const refresh = localStorage.getItem("refresh");
    console.log("content type ", config.headers);
    config.headers = {
      Authorization: `Bearer ${access ?? ""}`,
      "X-Refresh": refresh ?? "",
      Accept: "application/json",
      "Content-Type": config.headers["Content-Type"], // ?? 'application/json' /// TOBECHECKED
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);
// Response interceptor for API calls
axiosApiInstance.interceptors.response.use(
  (response) => {
    console.log("response ", response);
    return response;
  },

  async function (error) {
    const originalRequest = error.config;
    console.log("errorr", error.response);
    if (
      error.response.status === 403 &&
      !originalRequest._retry &&
      error.response.data["detail"] === "token_expired"
    ) {
      originalRequest._retry = true;
      const access_token = await refreshAccessToken();
      axiosApiInstance.defaults.headers.common["Authorization"] =
        "Bearer " + access_token;
      return axiosApiInstance(originalRequest);
    }
    return Promise.reject(error);
  },
);

async function refreshAccessToken() {
  try {
    // Make a request to your server to refresh the token
    const response = await axiosApiInstance.post("accounts/refresh/", {
      // Include any necessary data for refreshing the token
      // e.g., refresh token, user ID, etc.
    });

    // Extract and return the new token from the response
    setToken(response.data.access);
    localStorage.setItem("refresh", response.data.refresh);

    return response.data.access;
  } catch (error) {
    // Handle token refresh failure
    console.error("Token refresh failed:", error);
    throw error; // Rethrow the error for the calling function to handle
  }
}

export const setToken = (token) => {
  localStorage.setItem("token", token);
  console.log("settoken", token);
};

export const setAxiosAuthToken = (token) => {
  if (typeof token !== "undefined" && token) {
    //Apply the TOKEN for every request that we will make in the future.
    //axiosApiInstance.defaults.headers.common["Authorization"] = "Token " + token;
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  } else {
    //Delete auth header
    delete axios.defaults.headers.common["Authorization"];
  }
};
export const unsetCurrentUser = () => {
  setAxiosAuthToken(null);
  console.log("iam remiving");
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("kc_token_refresh");
  localStorage.removeItem("token_Key");
  localStorage.removeItem("refresh");
  localStorage.removeItem("index");
};

export const loginKcUser = (kcToken) => {
  //Headers
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  //Request body

  const body = JSON.stringify({ kcToken });
  console.log("response habib login", body);
  const promise = axiosApiInstance.post("accounts/kclogin/", body, config); //"rest-auth/login/"

  const dataPromise = promise.then((response) => {
    console.log("response habib", response.data.jwt);
    setToken(response.data.access);
    localStorage.setItem("refresh", response.data.refresh);
    localStorage.setItem("user", response.data.user.username);
    window.location.href = "/config";
    return response.data.jwt;
  });

  //setAxiosAuthToken = (token)
  return dataPromise;
};
export const logoutkc = async () => {
  const kcUri =
    "https://sso.ecoop.cloud/realms/masterpiece/protocol/openid-connect/logout";
  const token_kc = localStorage.getItem("kc_token_refresh");
  console.log("token successfully", token_kc);

  const details = {
    client_id: "sit-frontend",
    refresh_token: token_kc,
  };
  console.log("detailsss", details);
  unsetCurrentUser();

  await keycloak.logout({ redirectUri: "https://www.ecoop.cloud" });
  /*  const response = await axios.post(kcUri, details, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });*/
  //const userId = localStorage.getItem("user"); // Retrieve user ID from localStorage

  /*   axiosApiInstance
    .post("accounts/logout/", { user_id: userId })
    .then((response) => {
      ///logout/

      console.log("Logout successfully");
    });
 */
  // window.location.href = "/login";

  return;
};
